import { combineReducers } from 'redux';
import authReducer from './authReducer';
import balanceReducer from './balanceReducer';
import userServletReducer from './userServletReducer';
import contactServletReducer from './contactsServletReducer';
import repliesServletReducer from './repliesServletReducer';
import servletReducer from './servletReducer';

import othersReducer from './othersReducer';
import manageUserReducer from './manageUsersReducer';
import dialogsReducer from './dialogsReducer';
import statsReducer from './statsReducer';
import didsReducer from './didsReducer';
import paymentReducer from './paymentReducer';
import domainReducer from './domainReducer';
import filterReducer from './filterReducer';
import creativeReducer from './creativeReducer';
import offerReducer from './offerReducer';
import notificationReducer from './notificationReducer';
import guidelineReducer from './guidelineReducer';
import stateComponent from './stateComponent';
import processReducer from './processReducer';

export default combineReducers({
  guidelineReducer,
  offerReducer,
  creativeReducer,
  dialogsReducer,
  authReducer,
  balanceReducer,
  userServletReducer,
  contactServletReducer,
  repliesServletReducer,
  servletReducer,
  // inboxReducer,
  othersReducer,
  manageUserReducer,
  statsReducer,
  didsReducer,
  paymentReducer,
  domainReducer,
  notificationReducer,
  filterReducer,
  processReducer,
  stateComponent,
});
